import { LearnLevel } from '../../../../../common/src/model.ts';
import { PrimaryButton } from '../learn_buttons.tsx';
import { LevelChips } from '../learn_level_chips.tsx';
import { ScreenBody, ScreenSubtitle, ScreenTitle, Slack } from '../learn_screen_parts.tsx';
import { SingAlongSwitch } from '../learn_sing_along_switch.tsx';

// The Pitch Match start screen (issue #3518), in the shape of the Rhythm Echo one: a line about the
// exercise, the shared level chips, the sing-along toggle with its explanation, and Start. The Start
// tap is the user gesture that opens audio, so it is a real button and nothing starts on its own.
// The sing-along switch is shared with Sing in Solfège (learn_sing_along_switch.tsx).

export const pitchStartScreenId = 'pitch-start';
export const pitchStartButtonId = 'pitch-start-button';
export const pitchSingAlongSwitchId = 'pitch-sing-along-switch';

export const pitchStartTitle = 'Hear it, sing it, hold it';
export const pitchStartSubtitle = 'We play a note on the piano. Sing it back and hold it until it locks.';

export const PitchStartScreen = ({
  level,
  unlocked,
  selectable,
  singAlong,
  onSelectLevel,
  onToggleSingAlong,
  onStart,
}: {
  level: LearnLevel;
  unlocked: LearnLevel[];
  selectable: LearnLevel[];
  singAlong: boolean; // the device's stored choice, or its default
  onSelectLevel: (level: LearnLevel) => void;
  onToggleSingAlong: (singAlong: boolean) => void; // the value the switch was moved to
  onStart: () => void;
}) => (
  <ScreenBody id={pitchStartScreenId}>
    <ScreenTitle>{pitchStartTitle}</ScreenTitle>
    <ScreenSubtitle>{pitchStartSubtitle}</ScreenSubtitle>
    <LevelChips level={level} unlocked={unlocked} selectable={selectable} onSelectLevel={onSelectLevel} />
    <SingAlongSwitch id={pitchSingAlongSwitchId} singAlong={singAlong} onToggleSingAlong={onToggleSingAlong} />
    <Slack />
    <PrimaryButton id={pitchStartButtonId} data-testid={pitchStartButtonId} onClick={onStart}>
      Start
    </PrimaryButton>
  </ScreenBody>
);
